<div class="setting-con">
    <ul class="setting-nav">
        <li class="active">接听设置</li>
        <li>账号设置</li>
    </ul>
    <div class="setting-content">
        <div class="setting-content-item active" id="">
            <div class="mb20">
                <div class="tabletop clearfix">
                    <span class="fl">可咨询时段</span>
                    <a class="setT-btn fr" id="setTimeBtn">设置时段</a>
                </div>
                <table class="online-table">
                    <thead>
                        <tr>
                            {{each ServerTime item}}
                                <th>
                                    {{if item.WeekDate == 0}}
                                    星期天
                                    {{else if item.WeekDate == 1}}
                                    星期一
                                    {{else if item.WeekDate == 2}}
                                    星期二
                                    {{else if item.WeekDate == 3}}
                                    星期三
                                    {{else if item.WeekDate == 4}}
                                    星期四
                                    {{else if item.WeekDate == 5}}
                                    星期五
                                    {{else if item.WeekDate == 6}}
                                    星期六
                                    {{/if}}
                                </th>
                            {{/each}}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {{each ServerTime item}}
                                <td>
                                    <ul>
                                        {{if item.SeTime.length>0 && item.SeTime.length!==24 && item.SeTime[0] != ""}}
                                            {{each item.newArrTimeStr itemm}}
                                                <li>
                                                    {{itemm}}
                                                </li>
                                            {{/each}}
                                        {{else if item.SeTime.length>0 && item.SeTime.length==24}}
                                            <li>全天可通话</li>
                                        {{else}}
                                            <li>全天不可通话</li>
                                        {{/if}}
                                    </ul>
                                </td>
                            {{/each}}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tablemiddle clearfix mb20">
                <span class="fl">接听对象：
                {{if AnswerInfo.TallType == 0}}
                不限
                {{else if AnswerInfo.TallType == 1}}
                关注的用户
                {{else if AnswerInfo.TallType == 2}}
                <!--异性-->
                    {{if Sex == 1}}
                        女
                    {{else}}
                        男
                    {{/if}}
                {{else}}
                <!--同性-->
                    {{if Sex == 1}}
                        男
                    {{else}}
                        女
                    {{/if}}
                {{/if}}
                </span>
                <a class="setT-btn fr" id="setAnswer">设置</a>
            </div>
            <div class="tablebottom clearfix mb20">
                <div class="fl">
                    <h3>放电一小时</h3>
                    <h4>开启后您将更容易接到考米来电</h4>
                </div>
                <div class="fr">
                    {{if AnswerInfo.IsActive}}
                        <a class="close-btn" id="setCloseWinking">关闭</a>
                    {{else }}
                        <a class="setT-btn" id="setWinking">开启</a>
                    {{/if}}
                </div>
                <div class="fr">
                    {{if AnswerInfo.IsActive}}
                        <span class="fr" id="fandian">{{AnswerInfo.ActiveEndTime}}结束</span>
                    {{/if}}
                </div>
            </div>
            <div class="tablebottom clearfix mb20">
                <div class="fl">
                    <h3>临时免打扰</h3>
                    <h4>开启后您将暂时进入不可语聊状态，不会收到考米来电 </h4>
                </div>
                <div class="fr">
                    {{if AnswerInfo.IsNotDisturb}}
                        <a class="close-btn setNotDisturb">关闭</a>
                    {{else }}
                        <a class="setT-btn setNotDisturb">开启</a>
                    {{/if}}
                </div>
                <div class="fr">
                    {{if AnswerInfo.IsNotDisturb}}
                        <span class="fr" id="miandarao">{{AnswerInfo.NotDisturbEndTime}}结束</span>
                    {{/if}}
                </div>
            </div>
        </div>
        <div class="setting-content-item" id="">
            <div class="tablemiddle clearfix mb20">
                <span class="fl">修改密码</span>
                <a class="setT-btn fr" id="setPsd">修改</a>
            </div>
            <div class="tablemiddle clearfix mb20">
                <span class="fl">绑定手机号</span>
                <a class="setT-btn fr" id="bindPhone">修改</a>
                {{if Phone}}
                <h4 class="fr" style="font-size: 14px;padding: 0 20px">+86 {{Phone}}</h4>
                {{else}}
                <h4 class="fr" style="font-size: 14px;padding: 0 20px">暂未绑定手机号</h4>
                {{/if}}
            </div>
            <div class="tablebottom clearfix mb20">
                <div class="fl">
                    <h3>隐身浏览
                        <span class="badge">
                        <img src="../../../public/images/tab_vip_ico.png">
                        </span>
                    </h3>
                    <h4>浏览其他用户主页不会留下记录</h4>
                </div>
                <div class="fr">
                    {{if AnswerInfo.HiddenVisitStatus}}
                        <a class="close-btn setStealth">关闭</a>
                    {{else}}
                        <a class="setT-btn setStealth">开启</a>
                    {{/if}}
                </div>
            </div>
        </div>
    </div>
</div>

<div id="setTime-con" style="display: none">
    <div class="ui-dialog-title clearfix">
        <p>设置通话时段</p>
    </div>
    <div class="time-con clearfix">
        <ul class="day-con clearfix">
            <li class="active" data-day="0">星期日</li>
            <li data-day="1">星期一</li>
            <li data-day="2">星期二</li>
            <li data-day="3">星期三</li>
            <li data-day="4">星期四</li>
            <li data-day="5">星期五</li>
            <li data-day="6">星期六</li>
        </ul>
        <div class="hours-con">
            <div class="monday-wrap hours-wrap active">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="mondayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="mondayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="mondayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>
            <div class="tuesday-wrap hours-wrap">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="tuesdayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="tuesdayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="tuesdayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>
            <div class="wednesday-wrap hours-wrap">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="wednesdayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="wednesdayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="wednesdayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>
            <div class="thursday-wrap hours-wrap">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="thursdayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="thursdayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="thursdayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>
            <div class="friday-wrap hours-wrap">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="fridayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="fridayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="fridayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>
            <div class="saturday-wrap hours-wrap">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="saturdayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="saturdayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="saturdayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>
            <div class="sunday-wrap hours-wrap">
                <form class="layui-form" style="padding: 4px 0 10px 0">
                    <input type="radio" name="time" value="全天可通话" title="全天可通话" lay-filter="sundayAll">
                    <input type="radio" name="time" value="全天不可通话" title="全天不可通话" lay-filter="sundayNone">
                    <input type="radio" name="time" value="自定义" title="自定义" checked="" lay-filter="sundayCus">
                </form>
                <div class="integer-con clearfix">
                    <span data-id="0">0:00</span>
                    <span data-id="1">1:00</span>
                    <span data-id="2">2:00</span>
                    <span data-id="3">3:00</span>
                    <span data-id="4">4:00</span>
                    <span data-id="5">5:00</span>
                    <span data-id="6">6:00</span>
                    <span data-id="7">7:00</span>
                    <span data-id="8">8:00</span>
                    <span data-id="9">9:00</span>
                    <span data-id="10">10:00</span>
                    <span data-id="11">11:00</span>
                    <span data-id="12">12:00</span>
                    <span data-id="13">13:00</span>
                    <span data-id="14">14:00</span>
                    <span data-id="15">15:00</span>
                    <span data-id="16">16:00</span>
                    <span data-id="17">17:00</span>
                    <span data-id="18">18:00</span>
                    <span data-id="19">19:00</span>
                    <span data-id="20">20:00</span>
                    <span data-id="21">21:00</span>
                    <span data-id="22">22:00</span>
                    <span data-id="23">23:00</span>
                </div>        
            </div>        
        </div>
    </div>
    <div class="btn-wrap" style="">
        <a class="btn-save-all" id="synchEveryDay">保存并同步到每天</a>
        <a class="btn-save" id="saveServeT">保存</a>
    </div>
</div>

<div id="answer-con" style="display: none">
    <div class="ui-dialog-title clearfix">
        <p>接听对象</p>
    </div>
    <div class="clearfix">
        <form class="layui-form" style="padding: 0 80px; text-align: center">
            {{ if AnswerInfo.TallType == 0}}
            <!--不限-->
                <input type="radio" name="sex" value="不限" title="不限" checked="">
                <input type="radio" name="sex" value="男" title="男">
                <input type="radio" name="sex" value="女" title="女">
                <input type="radio" name="sex" value="关注的用户" title="关注的用户">
            {{ else if AnswerInfo.TallType == 1}}
            <!--关注的人-->
                <input type="radio" name="sex" value="不限" title="不限">
                <input type="radio" name="sex" value="男" title="男">
                <input type="radio" name="sex" value="女" title="女">
                <input type="radio" name="sex" value="关注的用户" title="关注的用户" checked="">
            {{ else if AnswerInfo.TallType == 2}}
             <!--异性-->
                {{if Sex == 1}}
                    <input type="radio" name="sex" value="不限" title="不限">
                    <input type="radio" name="sex" value="男" title="男">
                    <input type="radio" name="sex" value="女" title="女" checked="">
                    <input type="radio" name="sex" value="关注的用户" title="关注的用户"> 
                {{else}}
                    <input type="radio" name="sex" value="不限" title="不限">
                    <input type="radio" name="sex" value="男" title="男" checked="">
                    <input type="radio" name="sex" value="女" title="女">
                    <input type="radio" name="sex" value="关注的用户" title="关注的用户"> 
                {{/if}}
            {{ else }}
            <!--同性-->
                {{if Sex == 1}}
                    <input type="radio" name="sex" value="不限" title="不限">
                    <input type="radio" name="sex" value="男" title="男" checked="">
                    <input type="radio" name="sex" value="女" title="女">
                    <input type="radio" name="sex" value="关注的用户" title="关注的用户"> 
                {{else}}
                    <input type="radio" name="sex" value="不限" title="不限">
                    <input type="radio" name="sex" value="男" title="男">
                    <input type="radio" name="sex" value="女" title="女" checked="">
                    <input type="radio" name="sex" value="关注的用户" title="关注的用户"> 
                {{/if}}
            {{/if}}
        </form>
    </div>
    <div class="btn-wrap" style="">
        <a class="btn-save w180btn themeColor" id="saveAnswer">确定</a>
    </div>
</div>

<div id="winking-con" style="display: none">
    <div class="ui-dialog-title clearfix">
        {{if AnswerInfo.ActiveFreeCount==0}}
            <p>付费开启放电</p>
            <h4>今日免费放电次数已用完，后续需使用声币或积分进行放电。</h4>
        {{else if AnswerInfo.ActiveFreeCount>0}}
            <div>放电开启后1小时内更容易收到考米用户来电，本次放电免费，是否开启？</div>
        {{/if}}
    </div>
    {{if AnswerInfo.ActiveFreeCount==0}}
    <div class="clearfix">
        <form class="layui-form" id="winking-form-con" style="text-align: center">
            <input type="radio" name="fee" value="1" title="5声币放电" checked="">
            <input type="radio" name="fee" value="2" title="5000积分放电" checked="">
        </form>
    </div>
    {{/if}}
    <div class="btn-wrap" style="">
        {{if AnswerInfo.ActiveFreeCount==0}}
            <a class="btn-save w180btn themeColor" id="setTwinkle">开始放电</a>
        {{else if AnswerInfo.ActiveFreeCount>0}}
            <a class="btn-save w180btn themeColor" id="setTFreewinkle">开始放电</a>
        {{/if}}
        
    </div>
</div>

<div id="closeWinking-con" style="display: none">
    <div class="ui-dialog-title clearfix"></div>
    <div style="text-align: center;">是否关闭放电?</div>
    <div class="btn-wrap" style="padding: 40px 50px;text-align: center">
        <a class="w130btn themeColor" id="closeWinking">确定</a>
        <a class="w130btn cancleColor" id="cancelWinking">取消</a>
    </div>
</div>

<div id="newPsd-con" style="display: none">
    <div class="ui-dialog-title clearfix">
        <p>修改密码</p>
    </div>
    <div class="clearfix">
        <form class="layui-form" style="padding: 0 80px; text-align: center">
            <div class="form-data-item">
                <div class="form-block">
                    <input type="text" style="text-align: center" value="" class="currentPsd" placeholder="输入当前密码">
                </div>
            </div>
            <div class="form-data-item">
                <div class="form-block">
                    <input type="text" style="text-align: center" value="" maxlength='16' class="newPsd" onkeyup="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[ ]/g,'')" placeholder="输入新密码">
                </div>
            </div>
            <div class="form-data-item">
                <div class="form-block">
                    <input type="text" style="text-align: center" value="" maxlength='16' class="confirmNewPsd" onkeyup="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[ ]/g,'')" placeholder="确认前密码">
                </div>
            </div>
            <div class="mt10" style="text-align: center;color: #999">由6-16位的数字、字母或字符组成</div>
        </form>
    </div>
    <div class="btn-wrap" style="">
        <a class="btn-save w180btn themeColor" id="confirmResetPsd" onclick="">确认修改</a>
    </div>
</div>



<div id="private-con" style="display: none">
    <div style="text-align: center;font-size: 14px;padding: 70px 0 20px">
    VIP用户可开启此项，请先开通VIP
    </div>
    <div class="btn-wrap" style="text-align: center;padding: 20px 0">
        <a class="btn-save w180btn themeColor" href="./member.html">去开通</a>
    </div>
</div>


<div class="verBox" id="verBox" style="display: none;">
    <div class="verBox-title clearfix">
    <span class="fl">请完成安全验证</span>
    </div>
    <div style="padding: 19px">
    <div id="imgVer" style="display:inline-block;"></div>
    </div>
</div>

<!--开启免打扰-->
<div id="quite-con" style="display: none">
    <div class="ui-dialog-title clearfix"></div>
    <div style="color:#666;font-size: 14px;padding: 0 50px;">
        免打扰开启后24小时内不会收到考米用户来电，是否开启？
    </div>
    <div class="btn-wrap" style="padding: 40px 50px;text-align: center">
        <a class="w180btn themeColor" id="openQuite">确定</a>
    </div>
</div>

